'use strict';

import omniclone from 'omniclone';

import {
    BATCH_ACTIONS,
    PANELMANAGER_OPEN_PANEL_FOR_ITEMTYPE
} from '../../constants';

import Joi from '~/shared/src/utilities/joiExtended';

import openPanel, {
    PanelPropsWithPanelType,
    ProcessFinalPanelProps
} from '~/frontend/src/actions/panelManager/openPanel';
import {
    AppDispatch,
    StoreState,
    Thunk
} from '~/frontend/src/store';
import React from 'react';
import {
    PanelClass,
    panelClasses,
    PanelType
} from '~/frontend/src/components/base/page/PageTabPanel/definitions';
import {panelCreateNewItemSchema} from '~/frontend/src/components/base/page/PageTabPanel/utilities';


export type OpenPanelForItemTypeAction = {
    type : typeof PANELMANAGER_OPEN_PANEL_FOR_ITEMTYPE;
    subType : typeof BATCH_ACTIONS,
    itemType : number | string;
    panelProps : PanelProps;
    actions : any[];
};

/**
 * @memberOf! Actions
 *
 * @param {Schema} schema
 * @param {number|string} itemType
 * @param {PanelProps} panelProps
 * @param {ProcessFinalPanelProps} [processFinalPanelProps]
 * @param {React.MouseEvent<HTMLElement, MouseEvent>} [event]                  The mouse event which triggered the action call if.
 * @param {'generic' | 'nongeneric'} [openAlwaysInMode]
 * @param {PanelPropsWithPanelType['panelType'] | PanelPropsWithPanelType['panelType'] []} [excludePanelTypes=[]] panel types to be excluded, e.g. TreeView
 * @param {PanelPropsWithPanelType['panelType'] | PanelPropsWithPanelType['panelType'] []} [includePanelTypes=[]] panel types to be included, e.g. TreeView
 *
 * @return {OpenPanelAction | SetPanelPropsValidationErrorAction}
 */
const openPanelForItemType = ( schema : Schema, itemType : number | string, panelProps : PanelProps, processFinalPanelProps? : ProcessFinalPanelProps, event? : React.MouseEvent<HTMLElement, MouseEvent> | React.KeyboardEvent<HTMLElement>, openAlwaysInMode? : 'generic' | 'nongeneric', excludePanelTypes : PanelPropsWithPanelType['panelType'] | PanelPropsWithPanelType['panelType'][] = [], includePanelTypes : PanelPropsWithPanelType['panelType'] | PanelPropsWithPanelType['panelType'][] = [] ) : Thunk<void> => ( dispatch : AppDispatch, getState : () => StoreState ) => {
    panelProps = omniclone( panelProps );

    const user = getState().session.user;

    if ( user ) {
        const basePanelProps = user.getDefaultPanelPropsForItemType( schema, itemType, !!event?.altKey, openAlwaysInMode, excludePanelTypes, includePanelTypes );

        if ( basePanelProps?.panelType ) {
            const PanelComponent   = panelClasses[ basePanelProps.panelType as PanelType ] as unknown as PanelClass,
                  panelPropsSchema = Joi.object().concat( PanelComponent.panelPropsSchema ).concat( panelCreateNewItemSchema );

            panelProps = panelPropsSchema.validate(
                {
                    ...basePanelProps,
                    ...panelProps
                },
                {
                    abortEarly  : false,
                    convert     : false,
                    noDefaults  : true,
                    stripUnknown: true
                }
            ).value;

            dispatch( {
                type   : PANELMANAGER_OPEN_PANEL_FOR_ITEMTYPE,
                subType: BATCH_ACTIONS,
                itemType,
                panelProps,
                actions: [
                    openPanel( panelProps as PanelPropsWithPanelType, processFinalPanelProps, event )
                ]
            } );
        }
    }
}
export type OpenPanelForItemType = typeof openPanelForItemType;

export default openPanelForItemType;
